import { firestore, MODEL_COLL } from "_firebase";

import {
    getChbanzChecklistStart,
    getChbanzChecklistSuccess,
    getChbanzChecklistError,
    saveChecklistSuccess,
} from "./actions";

import { isEmpty } from "lodash";

export const getChbaNzChecklist = (modelId) => async (dispatch) => {
    try {
        dispatch(getChbanzChecklistStart());

        const chbaNzChecklist = await firestore
            .doc(`${MODEL_COLL}/${modelId}`)
            .collection("modelData")
            .doc("checklist")
            .get();

        const items = chbaNzChecklist.data();

        dispatch(getChbanzChecklistSuccess({ items }));
    } catch (error) {
        dispatch(getChbanzChecklistError(error));
    }
};

function sanitizeForFirestore(v) {
    const isFile = (x) => typeof File !== "undefined" && x instanceof File;
    const isBlob = (x) => typeof Blob !== "undefined" && x instanceof Blob;

    if (v === undefined) return null; // Firestore rejects undefined
    if (isFile(v) || isBlob(v)) return null; // strip Files/Blobs
    if (v instanceof Date) return v; // or use Timestamp.fromDate(v)
    if (Array.isArray(v)) return v.map(sanitizeForFirestore);
    if (v && typeof v === "object") {
        return Object.fromEntries(
            Object.entries(v)
                .filter(([, val]) => val !== undefined)
                .map(([k, val]) => [k, sanitizeForFirestore(val)])
        );
    }
    return v;
}

export const saveChbaNzChecklist =
    (isFromError = false) =>
    async (dispatch, getState) => {
        const { model: { modelId } = {}, chbaChecklist } = getState();

        // usage right before save:
        const cleaned = sanitizeForFirestore(chbaChecklist);

        if (!modelId || isEmpty(chbaChecklist)) {
            return;
        }

        try {
            await firestore.doc(`${MODEL_COLL}/${modelId}`).collection("modelData").doc("checklist").set(cleaned);

            // if (!isFromError) {
            dispatch(saveChecklistSuccess(chbaChecklist?.items || {}));
            // }
        } catch (err) {
            console.error("error saving CHBA checklist", err);
        }
    };
